import axios from "axios";
import { JWT } from "@/store/MUTATIONS-TYPES";

const http = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 50000,
});

http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(JWT);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      //redirecionar para o login
    }

    return Promise.reject(error);
  }
);

export default http;
